import { createContext, useContext, useState, useEffect } from 'react';
import * as api from '../services/api'

const ConfigContext = createContext();

export const ConfigProvider = ({ children }) => {

    const [configData, setConfigData] = useState(null);

    useEffect(() => {
   
        const fetchConfig = async () => {
            const response = await api.getReactConfig();
            if (response.status === 200) {
               setConfigData(response.data);
            } else {
                console.error("Error fetching config:");
            }
        }

        fetchConfig();
    }, []);

    if (!configData) {
        return <div>Loading ...</div>;
    }
  
    return (
        <ConfigContext.Provider value={{ configData }}>
            {children}
        </ConfigContext.Provider>
    )
}

export function useConfig (){
    const context = useContext(ConfigContext);
    if (!context) {
        throw new Error("useConfig debe usarse dentro de ConfigProvider");
    }
    return context;
}
